import React from "react";
import { Link } from "react-router-dom";

const Notice = ({ children, testId }) => (
  <p data-testid={testId} className="w-full text-center border border-[#3a3a2a] text-[#c9b978] text-xs uppercase tracking-[0.2em] py-4 mt-6 leading-relaxed">{children}</p>
);

const POLICY_LINKS = [["/terms", "terms"], ["/privacy", "privacy"], ["/shipping", "shipping_delivery"]];

const ConsentAndSubmit = ({ t, agreed, setAgreed, loading }) => (
  <>
    <label className="flex items-start gap-3 mt-6 cursor-pointer" data-testid="consent-label">
      <input type="checkbox" checked={agreed} onChange={(e) => setAgreed(e.target.checked)} data-testid="consent-checkbox" className="mt-0.5 w-4 h-4 accent-[#C49A6C] shrink-0" />
      <span className="text-xs text-[#8A857D] leading-relaxed">
        {t("consent_pre")}{" "}
        {POLICY_LINKS.map(([to, key], i) => (
          <React.Fragment key={to}>
            {i > 0 && " · "}
            <Link to={to} target="_blank" className="text-[#C49A6C] hover:underline">{t(key)}</Link>
          </React.Fragment>
        ))}
      </span>
    </label>
    <button type="submit" disabled={loading || !agreed} data-testid="place-order-btn" className="w-full bg-[#C49A6C] text-[#0B0A08] text-xs uppercase tracking-[0.25em] py-4 mt-4 hover:bg-[#E7CBA9] transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
      {loading ? "…" : t("place_order")}
    </button>
  </>
);

export const CheckoutAction = ({ t, salesOpen, intlDisabled, agreed, setAgreed, loading }) => {
  if (!salesOpen) return <Notice testId="sales-closed-banner">{t("sales_closed_msg")}</Notice>;
  if (intlDisabled) return <Notice>{t("intl_soon")}</Notice>;
  return <ConsentAndSubmit t={t} agreed={agreed} setAgreed={setAgreed} loading={loading} />;
};

export const shippingLabel = ({ t, money, loading, known, feeAed, estimated }) => {
  if (loading) return "…";
  if (!known) return t("shipping_tba");
  if (feeAed === 0) return t("free_shipping");
  return estimated ? `${money(feeAed)} (${t("estimated_label")})` : money(feeAed);
};
